import { render, staticRenderFns } from "./DetalleIsrRetenido.vue?vue&type=template&id=75be3c54"
import script from "./DetalleIsrRetenido.vue?vue&type=script&lang=js"
export * from "./DetalleIsrRetenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75be3c54')) {
      api.createRecord('75be3c54', component.options)
    } else {
      api.reload('75be3c54', component.options)
    }
    module.hot.accept("./DetalleIsrRetenido.vue?vue&type=template&id=75be3c54", function () {
      api.rerender('75be3c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DetalleIsrRetenido.vue"
export default component.exports